const discoverRelatedActionTypes = {
  GET_DISCOVER_RELATED_START: "GET_DISCOVER_RELATED_START",
  GET_DISCOVER_RELATED_SUCCESS: "GET_DISCOVER_RELATED_SUCCESS",
  GET_DISCOVER_RELATED_FAILURE: "GET_DISCOVER_RELATED_FAILURE",
};

export default discoverRelatedActionTypes;
